export const blockIconsHardwareLaptop = (
	<span className='material-symbols-outlined'>laptop</span>
);
